// this is where will be setting the logic for users policies  later.
import router from './router'
import firebase from 'firebase'


router.beforeEach((to, from, next) => {

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth) {
    firebase.auth().onAuthStateChanged(function (user) {
      if (!user) {

        next('/');
      } else {

        next()
      }
    });


  } else {

    next()

  }


});



// WEBPACK FOOTER //
// ./src/permission.js